import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UserAudit } from 'src/app/core/models/userAudit';
import { AuthService } from 'src/app/core/services/auth.service';
import { HyundaiBluelinkService } from 'src/app/core/services/hyundaiBluelink.service';

@Component({
  selector: 'app-hyundai-position',
  templateUrl: './hyundai-position.component.html',
  styleUrls: ['./hyundai-position.component.scss'],
  providers: [DatePipe],
})

export class HyundaiPositionComponent implements OnInit {
  constructor(
    private hyundaiBluelinkService: HyundaiBluelinkService,
    public datePipe: DatePipe,
    private authService: AuthService
  ) {
    this.userAudit = new UserAudit(
      this.authService.currentUserValue,
      'packets/hyundaiposition'
    );
  }

  userAudit: UserAudit

  activeTab: string = 'tab1';
  chassiPosition: string = '';
  responsePosition: any = null;
  chassiHistory: string = '';
  historyChassi: any[] = [];
  expandedTab: string = '';
  messageErrorTab1: string = '';
  messageErrorTab2: string = '';
  responsePositionStatus: string = '';
  chassiNotFound : string = '';

  ngOnInit() {
    this.toggleTab(this.activeTab);
  }

  toggleTab(tab: string) {
    this.expandedTab = this.expandedTab === tab ? '' : tab; // Alterna entre expandir e colapsar
  }

  getPosition() {
    this.responsePosition = '';
    this.responsePositionStatus = '';
    if (!this.chassiPosition) {
      this.messageErrorTab1 = 'Digite o chassi!';
      return;
    }  
    if (this.chassiPosition.length != 17) {
      this.messageErrorTab1 = 'O campo chassi precisa receber 17 caracteres!';
      return;
    }  
    else {
      const confirmacao = window.confirm('Esta solicitação poderá gerar custos!\n\nDeseja realmente prosseguir com a solicitação?');
      if (confirmacao) {      
        this.messageErrorTab1 = '';
        this.hyundaiBluelinkService.getPositionHyundai(this.chassiPosition, this.userAudit).subscribe((response: any) => {
        this.responsePosition = JSON.parse(JSON.stringify(response))
        if (this.responsePosition.status == "success")
            this.responsePositionStatus = "success"; 
        })
      }
      else {
        this.messageErrorTab1 = '';
        }
      }
  }

  convertForDate(requestDate: string): Date {
    const ano = requestDate.substring(0, 4);
    const mes = requestDate.substring(4, 6);
    const dia = requestDate.substring(6, 8);
    const horas = requestDate.substring(8, 10);
    const minutos = requestDate.substring(10, 12);
    const segundos = requestDate.substring(12, 14);

    return new Date(`${ano}-${mes}-${dia}T${horas}:${minutos}:${segundos}`);
  }

  getHistory() {
    this.historyChassi = [];
    this.chassiNotFound = '';
    if (!this.chassiHistory) {
      this.messageErrorTab2 = 'Digite o chassi!';
      return;
    }  
    if (this.chassiHistory.length != 17) {
      this.messageErrorTab2 = 'O campo chassi precisa receber 17 caracteres!';
      return;
    }  
    else {
        this.messageErrorTab2 = '';
        this.hyundaiBluelinkService.getHistoryHyundai(this.chassiHistory, this.userAudit).subscribe((response: any) => {
          if (response.history.includes("Não foi localizado registros para o chassi informado!")){
            this.chassiNotFound = "Não foi localizado registros para o chassi informado!";
            }
          else{
            const array = response.history; 
            const date_array_formatted = this.formatDateUtc(array);
            this.historyChassi = date_array_formatted;
            this.sortByDate();
            }
        }
      )
    }
  }

  formatDateUtc(value : []) {
    const especificDate = new Date("2025-04-28T19:44:00"); //data em que passou a salvar em UTC no DB
    const date_array_formatted = value.map((date: { request_date: string }) => {
    let dataOriginal = this.convertForDate(date.request_date);

    if (dataOriginal > especificDate) {
      //Subtração de 3 horas no formato UTC
      dataOriginal = new Date(dataOriginal.getTime() - 3 * 60 * 60 * 1000);
      }     
    
      return {
        //substitui o valor de request_date
        ...date, // Mantendo o formato "YYYYMMDDHHmmss"
        request_date: dataOriginal.getFullYear() +
            String(dataOriginal.getMonth() + 1).padStart(2, '0') +
            String(dataOriginal.getDate()).padStart(2, '0') +
            String(dataOriginal.getHours()).padStart(2, '0') +
            String(dataOriginal.getMinutes()).padStart(2, '0') +
            String(dataOriginal.getSeconds()).padStart(2, '0') 
          }             
        } 
      )
      return date_array_formatted;
  }

  sortByDate() {
    this.historyChassi.sort((a, b) => {
      return Number(b.request_date) - Number(a.request_date); 
    });
  }
}
